import React from 'react';

import { observer } from 'mobx-react';

import classes from './ScanIqAutomatedPayment.module.scss';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { angularizeWithProviders } from '../../../../shared/providers';
import { ConnectStripeWidget } from '../../../containers/ConnectStripeWidget/ConnectStripeWidget';
import { ScanIqSubscriptionsManagement } from '../../../containers/EntitySubscriptionsManagement/ScanIqSubscriptionsManagement/ScanIqSubscriptionsManagement';
import { ScanIqTaxWidget } from '../../../containers/ScanIqTaxWidget/ScanIqTaxWidget';

type ScanIqAutomatedPaymentProps = {
  entityId: number;
  isStripeConnected: boolean;
};

const ScanIqAutomatedPayment = observer(
  ({ entityId, isStripeConnected }: ScanIqAutomatedPaymentProps) => {
    const { isSuperAdmin } = loggedInUserDataStore;

    return (
      <>
        <div className={classes.row}>
          <ConnectStripeWidget
            entityId={entityId}
            isStripeConnected={isStripeConnected}
            disabled={isSuperAdmin}
          />
          <ScanIqTaxWidget entityId={entityId} />
        </div>
        <ScanIqSubscriptionsManagement entityId={entityId} />
      </>
    );
  },
);

angularizeWithProviders(ScanIqAutomatedPayment, 'ngzScanIqAutomatedPaymentTab', {
  entityId: '<',
  isStripeConnected: '<',
});

export { ScanIqAutomatedPayment };
